/** @format */

import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import { Helmet } from "react-helmet";
import { metaDescription } from "./components/Utils";
import LandingPage from "./pages/LandingPage";
import PropertyPage from "./pages/PropertyPage";
import OptOutPage from "./pages/OptOutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import NewHeader from "./components/NewHeader";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme";
import NewFooter from "./components/NewFooter";
import OldApp from "./OldApp";
import SearchPage from "./pages/SearchPage";
import ServicePage from "./pages/ServicePage";
import Perspective from "./pages/Perspective";
import About from "./pages/AboutPage";
import Portfolio from "./pages/PortfolioPage";
import Article from "./pages/Article";
import ArticleOne from "./pages/Article-One";
import ArticleTwo from "./pages/Article-Two";
import ArticleThree from "./pages/Article-three";
import TenantPage from "./pages/TenantPage";
import HeapAnalytics from "./components/HeapAnalytics";
import { AnalyticsTracker2 } from "./components/Analytics";
import { PropertyRedirect } from "./components/old-site/OldSiteRedirects";
import TenantInfoFormPage from "./pages/TenantInfoForm";

const pageConfigs = [
  {
    route: "/",
    isDarkBackground: true,
    searchOption: false,
    footer: true,
  },
  {
    route: "/property",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/search",
    isDarkBackground: false,
    searchOption: true,
    footer: false,
  },
  {
    route: "/what-we-do",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/understanding-the-leasing-process",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/what-is-mob",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/healthcare-real-estate-terms-simplified",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/perspective",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/benefits-of-leasing",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/who-we-are",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/portfolio",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/current-tenants",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/opt-out",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
  {
    route: "/privacy-policy",
    isDarkBackground: false,
    searchOption: false,
    footer: true,
  },
];

// TODO - migrate each of these routes to Chakra styling and move from OldApp.js to App.js
const oldAppPages = [
  //"/new-tenant",
  //"/tenant-contact",
  //"/tenant-contact-cc",
  "/search/",
  //"/old",
]

class App extends Component {

  constructor() {
    super();
    this.state = {
      cookiesAccepted: false,
    };
  }

  onCookiesAccept() {
    this.setState({cookiesAccepted: true});
  }

  render() {
    const currentRoute = window.location.pathname;
    console.log('currentRoute', currentRoute);
    const currentPageConfig = pageConfigs.find(
      (config) => config.route === currentRoute
    );

    //if (!currentPageConfig) {
    //  return null; // Return null or a default component if the route is not found in pageConfigs
    //}
    return (
      <>
        {oldAppPages.find(url=>currentRoute.startsWith(url)) ? (
          <OldApp />
        ) : (
          <ChakraProvider theme={theme}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <CompatRouter>
                <div className="App">
                  <Helmet>
                    <title>
                      Welltower Medical Office For Lease - Building Space For
                      Rent
                    </title>
                    <meta name="description" content={metaDescription()} />
                  </Helmet>
                  <AnalyticsTracker2
                    trackingId={process.env.REACT_APP_GA4_TOKEN}
                    gtmTrackingId={process.env.REACT_APP_GTM_TOKEN}
                    onCookiesAccept={() => {this.onCookiesAccept()}}
                  />
                  <HeapAnalytics heapAppId={process.env.REACT_APP_HEAP_APPID} cookiesAccepted={this.state.cookiesAccepted} />
                  <NewHeader
                    isDarkBackground={currentPageConfig?.isDarkBackground}
                    searchOption={currentPageConfig?.searchOption}
                  />
                  {/* <Header /> */}

                  <Route
                    render={(props) => (
                      <>
                        <Switch>
                          <Route
                            exact
                            path="/"
                            render={(props) => (
                              <LandingPage {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/current-tenants"
                            render={(props) => (
                              <TenantPage {...this.props} {...props} />
                            )}
                          />
                          <Route
                              exact
                              path={[
                                "/refer",
                                "/referral",
                                "/tenantreferral",
                                "/tenant-referral",
                              ]}
                              render={(props) => (
                                  <TenantPage {...this.props} {...props} showReferralForm />
                              )}
                          />
                          <Route
                            exact
                            path="/property"
                            render={(props) => (
                                <PropertyRedirect {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/search"
                            render={(props) => (
                              <SearchPage {...this.props} {...props} />
                            )}
                          />
                          <Route
                              exact
                              path="/new-tenant"
                              render={(props) => (
                                  <TenantInfoFormPage mode={"New Tenant"} />
                              )}
                          />
                          <Route
                              exact
                              path="/tenant-contact"
                              render={(props) => (
                                  <TenantInfoFormPage mode={"Tenant Contact"} />
                              )}
                          />
                          <Route
                              exact
                              path="/tenant-contact-cc"
                              render={(props) => (
                                  <TenantInfoFormPage mode={"Tenant Contact Commercial Cafe"} />
                              )}
                          />
                          <Route
                            exact
                            path="/what-we-do"
                            render={(props) => (
                              <ServicePage {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/perspective"
                            render={(props) => (
                              <Perspective {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/who-we-are"
                            render={(props) => (
                              <About {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/portfolio"
                            render={(props) => (
                              <Portfolio {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path={[
                              "/understanding-the-leasing-process",
                              "/understanding-the-leases-process", // old typo, keep for a little while
                            ]}
                            render={(props) => (
                              <Article {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/what-is-mob"
                            render={(props) => (
                              <ArticleOne {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/healthcare-real-estate-terms-simplified"
                            render={(props) => (
                              <ArticleTwo {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/benefits-of-leasing"
                            render={(props) => (
                              <ArticleThree {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/privacy-policy"
                            render={(props) => (
                              <PrivacyPolicyPage {...this.props} {...props} />
                            )}
                          />
                          <Route
                            exact
                            path="/opt-out"
                            render={(props) => <OptOutPage {...this.props} {...props} />}
                          />
                          <Route
                              exact
                              path="/:propertyId"
                              render={(props) => (
                                  <PropertyPage {...this.props} {...props} />
                              )}
                          />
                        </Switch>
                      </>
                    )}
                  />
                  {!oldAppPages.find(url=>currentRoute.startsWith(url)) && (currentRoute !== '/search') && <NewFooter />}
                </div>
              </CompatRouter>
            </BrowserRouter>
          </ChakraProvider>
        )}
      </>
    );
  }
}

export { App as default };
